module.exports = __webpack_public_path__ + "img/tv.103f103e.svg";